import { StringParam, useQueryParam } from 'use-query-params';
import { useTranslation } from 'react-i18next';

export enum PostsAddNewProfileReason {
  'noProfile' = 'noProfile',
  'demo' = 'demo',
}

export function useAddNewProfileReasonMessages(props: {
  isInFirstStep: boolean;
}) {
  const [reason] = useQueryParam('reason', StringParam);
  const { t } = useTranslation();

  function getReasonWording(
    reason: `${PostsAddNewProfileReason}` | string | null | undefined,
  ) {
    switch (props.isInFirstStep ? reason : undefined) {
      case 'noProfile':
        return {
          title: t('postsAddNewProfileReasons.noProfile.title'),
          description: t('postsAddNewProfileReasons.noProfile.description'),
        };
      case 'demo':
        return {
          title: t('postsAddNewProfileReasons.demo.title'),
          description: t('postsAddNewProfileReasons.demo.description'),
        };
      default:
        return {
          title: t('addProfile'),
          description: undefined,
        };
    }
  }

  return getReasonWording(reason);
}
